import { createContext, useContext } from "react";
import { Permission } from "@api/shared-runtime/enums";

// Create organization context
type Organization = {
  id: string;
  name: string;
};

type OrganizationBusinessUnit = {
  id: string;
  name: string;
  permissions?: Permission[];
  enableHiringProcess?: boolean;
  enableDocumentSigning?: boolean;
  enableProviderSearch?: boolean;
  skipJobPostReview?: boolean;
  enablePrimarySourceVerification?: boolean;
  timezoneId?: string;
};

type OrganizationContextType = {
  selectedOrg: Organization;
  selectedOrgBusinessUnit: OrganizationBusinessUnit;
};

export const OrganizationContext = createContext<
  OrganizationContextType | undefined
>(undefined);

// Hook to use the organization context
export const useOrganization = () => {
  const context = useContext(OrganizationContext);
  if (!context) {
    throw new Error("useOrganization must be used within an OrgLayout");
  }
  return context;
};
